<template>
  <div>
    <div class="link-button-box">
      <ButtonToExamResult />
    </div>
    <div class="scoring-input">
      <h2 class="scoring-input-title">採点入力ページ（{{ examScoring.applicantName }}）</h2>
      <b-form class="scoring-input-form" action="/api/applicant_scoring/" method="POST">
        <table class="scoring-input-table">
          <tr>
            <th>コンテナ</th>
            <td>
              <b-btn class="conect-container-button" @click="connectContainer">コンテナに接続</b-btn>
              <b-btn
                class="down-container-button"
                :disabled="!isContainerRunning"
                @click="downContainer"
              >
                コンテナを停止
              </b-btn>
            </td>
          </tr>
          <tr>
            <th>コンテナのパスワード</th>
            <td>{{ examScoring.containerPassword }}</td>
          </tr>
          <tr>
            <th>感想（入力フォームより）</th>
            <td v-if="examScoring.thoughtContent == null">
              未入力
            </td>
            <td v-else-if="examScoring.thoughtContent == ''">
              未入力で送信済み
            </td>
            <td v-else class="thought-content">{{ examScoring.thoughtContent }}</td>
          </tr>
          <tr>
            <th>最高TC通過数</th>
            <td>{{ examScoring.bestPassCase + '/' + examScoring.totalBestTestCase }}</td>
          </tr>
          <tr>
            <th>最終TC通過数</th>
            <td>{{ examScoring.lastPassCase + '/' + examScoring.totalLastTestCase }}</td>
          </tr>
          <tr>
            <th>開発者の採点結果</th>
            <td>
              <b-form-select
                id="select_scoring"
                name="scoring"
                v-model="scoringSelected"
                :options="scoring"
                class="select-scoring"
                :class="selectScoringClass"
                @change="updateSelectBoxColor"
              />
            </td>
          </tr>
          <tr>
            <th>評価理由コメント</th>
            <td>
              <div class="comment-box">
              <span class="comment-edit" v-b-modal.modal_comment>
                <img class="comment-edit-icon" :src="pencil">
              </span>
              <div class="comment-content">{{ examScoring.commentContent }}</div>
            </div>
            </td>
          </tr>
        </table>
        <input type="hidden" name="applicantId" :value="examScoring.applicantId">
        <input type="hidden" name="recruiterId" :value="recruiterId">
        <b-button
          id="scoring_submit_button"
          type="submit"
          :variant="scoringSelected ? 'primary' : 'secondary'"
          :disabled="!scoringSelected"
          class="scoring-submit-button"
        >
          確定
        </b-button>
      </b-form>
    </div>

    <b-modal
      id="modal_comment"
      ref="modal"
      size="xl"
      hide-footer
      centered
      title="評価理由コメント"
    >
      <!--
        form タグの target 属性に iframe を指定して,
        submit ボタンがクリックされた時に画面遷移されないようにしている
      -->
      <b-form action="/api/comment/" method="POST" target="sendPhoto">
        <b-form-textarea
          id="comment_textarea"
          name="commentContent"
          v-model="editorCommentContent"
          maxlength="1000"
          class="comment-textarea"
        />
        <input type="hidden" name="applicantId" :value="examScoring.applicantId">
        <input type="hidden" name="recruiterId" :value="recruiterId">
        <div class="comment-modal-footer">
          <b-button type="submit" @click="updateComment">更新</b-button>
        </div>
      </b-form>
      <iframe name="sendPhoto" class="hidden-iflame"/>
    </b-modal>

  </div>
</template>

<script>
import ButtonToExamResult from '@/main/frontend/components/ButtonToExamResult.vue';
import pencil from '@/main/frontend/assets/pencil.png';
export default {
  components: {
    ButtonToExamResult,
  },
  data() {
    return {
      recruiterId: null,
      pencil: pencil,
      isContainerRunning: false,
      isRunningTimer: null,
      scoringSelected: null,
      scoring: [
        {value: null, text: '未採点'},
        {value: 'SUPER_OK', text: '好通過'},
        {value: 'OK', text: '通過'},
        {value: 'NG', text: '非通過'},
      ],
      selectScoringClass: null,
      selectedNullClass: null,
      editorCommentContent: '',
      examScoring: {
        applicantId: null,
        applicantName: null,
        port: null,
        containerTag: null,
        containerPassword: null,
        thoughtContent: null,
        bestPassCase: null,
        lastPassCase: null,
        totalBestTestCase: null,
        totalLastTestCase: null,
        scoring: null,
        recruiterName: null,
        commentContent: null,
      },
    };
  },
  mounted() {
    // recruiterId を取得
    this.$axios
      .get('/api/recruiter/id')
      .then((response) => (this.recruiterId = response.data));

    // examScoring を取得
    const applicantId = this.$route.query.applicant_id;
    this.$axios
      .get('/api/exam_scoring/' + applicantId)
      .then((response) => {
        this.examScoring = response.data;

        // コンテナが走っているかどうか確認
        this.$axios.get('/api/container/is_container_running/' + this.examScoring.applicantId)
          .then((res) => {
            if (res.data) { // コンテナが走っている場合、コンテナ停止ボタンが有効になる
              Promise.resolve()
                .then(() => (this.isContainerRunning = true))
                .catch((e) => {
                  // TODO: postに失敗したときの処理
                });
            }
          });

        // すでに採点済みの場合、初期値として採点結果を挿入
        if (this.examScoring.scoring != null) {
          this.scoring[0].text = this.examScoring.scoring + '(' + this.examScoring.recruiterName + ')';
          switch (this.examScoring.scoring) {
            case '好通過':
              this.selectedNullClass = 'super-ok';
              break;
            case '通過':
              this.selectedNullClass = 'ok';
              break;
            case '非通過':
              this.selectedNullClass = 'ng';
              break;
            default:
              break;
          }
          this.changeSelectBoxColor(this.examScoring.scoring);
        }
        this.editorCommentContent = this.examScoring.commentContent;
      });
  },
  methods: {
    connectContainer() {
      this.$axios.get('/api/container/is_container_running/' + this.examScoring.applicantId)
        .then((res) => {
          if (res.data) { // コンテナが run 状態の場合, 別タブで VScode Server のページを開く
            Promise.resolve()
              .then(() => {
                this.openVScodeServer();
                this.isContainerRunning = true;
              })
              .catch((e) => {
                // TODO: postに失敗したときの処理
              });
          } else { // コンテナが run 状態ではない場合, run する
            this.$axios.post('/api/container/run/' + this.examScoring.applicantId)
              .then(() => {
                // コンテナがrunしているかを定期的に確認するタイマーを設置
                this.isRunningTimer = setInterval(() => {
                  this.$axios.get('/api/container/is_container_running/' + this.examScoring.applicantId)
                    .then((res) => {
                      // コンテナが走っていることが確認できたら、別タブで VScode Server のページを開き,
                      // タイマーによるループを抜ける
                      if (res.data) {
                        clearInterval(this.isRunningTimer);
                        const sleep = (msec) => new Promise((resolve) => setTimeout(resolve, msec));
                        (async () => {
                          await sleep(3000);
                          Promise.resolve()
                            .then(() => {
                              this.openVScodeServer();
                              this.isContainerRunning = true;
                              return;
                            })
                            .catch((e) => {
                              // TODO: postに失敗したときの処理
                            });
                        })();
                      }
                    });
                }, 100);
              });
          }
        });
    },
    downContainer() {
      this.isContainerRunning = false;
      this.$axios.post('/api/container/down/' + this.examScoring.applicantId)
        .catch((e) => {
          this.isContainerRunning = true;
        });
    },
    openVScodeServer() {
      window.open(`${location.protocol}//${location.hostname}:${this.examScoring.port}`);
    },
    updateSelectBoxColor() {
      const serectScoring = document.getElementById('select_scoring');
      this.changeSelectBoxColor(serectScoring.value);
    },
    // 開発者の採点結果によってセレクトボックスの色を変更する
    changeSelectBoxColor(value) {
      switch (value) {
        case 'SUPER_OK':
          this.selectScoringClass = 'super-ok';
          break;
        case 'OK':
          this.selectScoringClass = 'ok';
          break;
        case 'NG':
          this.selectScoringClass = 'ng';
          break;
        default:
          this.selectScoringClass = this.selectedNullClass;
          break;
      }
    },
    updateComment() {
      this.examScoring.commentContent = this.editorCommentContent;
      this.$refs['modal'].hide();
    },
  },
};
</script>

<style scoped>
.scoring-input {
  margin: 15px 15px 0;
}
.scoring-input-title {
  font-size: 20px;
  margin: 0 auto 10px;
  max-width: 1200px;
}
.scoring-input-form {
  text-align: center;
}
.scoring-input-table {
  border-collapse: collapse;
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
}
.scoring-input-table th {
  border: 2px solid #dee2e6;
  width: 220px;
  padding: 12px;
}
.scoring-input-table td {
  border: 2px solid #dee2e6;
  padding: 12px 40px;
}
.down-container-button {
  margin-left: 10px;
}
.thought-content {
  text-align: left;
}
.select-scoring {
  width: 250px;
}
.super-ok {
  background-color: #c3e6cb;
}
.ok {
  background-color: #ffeeba;
}
.ng {
  background-color: #f5c6cb;
}
.comment-box {
  min-height: 24px;
  position: relative;
}
.comment-edit {
  border-radius: 3px;
  cursor: pointer;
  position: absolute;
  right: -25px;
  top: 0;
  width: 24px;
}
.comment-edit:active {
  background-color: #6c757d;
}
.comment-edit-icon {
  margin-bottom: 4px;
  width: 16px;
}
.comment-textarea {
  height: 500px;
}
.comment-modal-footer {
  margin-top: 15px;
  text-align: center;
}
.comment-content {
  text-align: left;
  word-break: break-all;
}
.scoring-submit-button {
  display: block;
  margin-left: calc(50% + 75px);
  margin-top: 10px;
  width: 70px;
}
.hidden-iflame {
  border: 0;
  height: 0;
  width: 0;
}
</style>
